import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  Toolbar,
  IconButton,
  Typography,
  Button,
  AppBar,
} from "@material-ui/core";
import { DataContext } from "../Context/Context";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  offset: theme.mixins.toolbar,
  root: {
    flexGrow: 1,
    width: "100%",
    top: 0,
  },
  grow: {
    flexGrow: 1,
  },
  appBarBottom: {
    bottom: "auto",
    top: 0,
  },
  logo: {
    width: "60px",
  },
  noEntriesText: {
    fontSize: 20,
  },
  categoriesLink: {
    textDecoration: "none",
    color: "#6200ee",
  },
  iconBtn: {
    position: "absolute",
    right: 20,
  },
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  picture: {
    borderRadius: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Navbar() {
  const classes = useStyles();
  let location = useLocation();

  const { apiData } = useContext(DataContext);

  return (
    <>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBarTop}>
        <Toolbar>
          <Button edge="start" color="inherit">
            <img
              className={classes.logo}
              src={require("../images/logo.png").default}
              alt="logo"
            />
          </Button>

          <Typography variant="h6">
            {location.pathname === "/overview"
              ? "Overview"
              : location.pathname === "/categories"
              ? "Categories"
              : "Statistics"}
          </Typography>
          <IconButton
            className={classes.iconBtn}
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
          >
            {"results" in apiData && (
              <img
                className={classes.picture}
                src={apiData.results[0].picture.thumbnail}
                alt="profile-picture"
              />
            )}
          </IconButton>
        </Toolbar>
      </AppBar>
    </>
  );
}
